import React from 'react';
import BaseSidebar from '../../../shared/components/layouts/BaseSidebar';
import { FaLock, FaUsers, FaBars } from 'react-icons/fa';
import { useCanvas } from '../../context/CanvasContext';

const menuItems = [
  'Accounts',
  'Income',
  'Budget',
  'Savings',
  'Debts',
  'Mortgage',
  'Investments',
  'Subscriptions',
  'History',
  'Help & Resources'
];

const Sidebar = ({ onSectionChange, activeSection, isSidebarOpen, onToggle }) => {
  const { selectedCanvas } = useCanvas();

  const getTitle = () => {
    const icon = selectedCanvas?.type === 'private' ? 
      <FaLock className="text-white text-sm mr-2" /> : 
      <FaUsers className="text-white mr-2" />;
    
    return (
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center">
          {icon}
          <span>{selectedCanvas?.name}</span>
        </div>
        {/* <button
          onClick={onToggle}
          className="p-2 rounded-lg hover:bg-btn-secondary transition-colors"
        >
          <FaBars className={`text-white transform transition-transform duration-300 ${
            isSidebarOpen ? '' : 'rotate-180'
          }`} />
        </button> */}
      </div>
    );
  };

  return (
    <BaseSidebar
      items={menuItems}
      onSectionChange={onSectionChange}
      activeSection={activeSection}
      title={getTitle()}
    />
  );
};

export default Sidebar;
